import { SquareOnlineStoreProjectType } from '__generated__/types';

export function minPriceForProjectType(projectType: SquareOnlineStoreProjectType): number {
    switch (projectType) {
        case SquareOnlineStoreProjectType.NEW_SITE:
            return 30000;
        case SquareOnlineStoreProjectType.RECREATE_SITE:
            return 30000;
        case SquareOnlineStoreProjectType.MINOR_CHANGES:
            return 5000;
        case SquareOnlineStoreProjectType.MAJOR_CHANGES:
            return 30000;
    }
}
